import React from 'react';
// template components
import Carousel from '@nmx/template/dist/componentLibrary/modules/Carousel';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// styles
import { ColStyled } from './styles';
// utils
import { getCampaignData } from '../../utils/campaignDataEngine';

const data = getCampaignData();

const videoSlides = [
  {
    data: {
      heading: 'A flexible career', // optional heading
      videoId: '-PAcM41CRes',
    },
  },
  {
    data: {
      heading: 'Day in the Life of a Financial Advisor – Jamie Mannarelli', // optional heading
      videoId: '7SlQuS7AOgQ',
    },
  },
];

// reverse the video slides order for the women experience.
// NOTE: If they ever add more videos or make the video order more complex, we will need to write new logic.
if(data.campaignName === 'rec-wom'){
  videoSlides.reverse();
}

const config = {
  swiperCarousel: {
    autoplay: false, // boolean // auto-rotate slides
    autoplayDelay: 5000, // slide transition time
    isActive: true,
    slides: videoSlides,
  },
};

export default () => (
  <SectionContainer
    id='testimonials-recruitment-campaign' // '-section-container' will be appended dynamically
    backgroundVariant='lightB'
    className='nmx-no-print'
    themeType='lightTheme'
    moduleName='testimonials-module'
    moduleVariation='A'
    disableBottomPadding>
    <Row align='center'>
      <Col
        align='center'
        medium={10}
        large={8}>
        <Typography
          component='h2'
          nextElement='typography'>
          How this career changed the game <WidowBlock>for them</WidowBlock>
        </Typography>
        <Typography nextElement='graphic'>
          See what these Northwestern Mutual financial advisors have to say about the career and how a typical day is anything but.
        </Typography>
      </Col>
    </Row>
    <Row align='center'>
      <ColStyled>
        <Carousel
          data-app-name='nmx-static-react'
          data-static-config={config}
        />
      </ColStyled>
    </Row>
  </SectionContainer>
);
